import { IAction, clone, EModalType, IdHelper, IOutput, IFieldConfig, IFieldDictionary, IFieldError } from '../../helpers/';
import { DEFAULT_ACTION, DEFAULT_ACTION_OUTPUT } from '../../constants';
import types from '../types';
import { IDropdownOption } from 'office-ui-fabric-react';

export interface IActionConfigState {
    action: IAction;
    fieldConfigs: IFieldConfig[];
    entityFields: IDropdownOption[];
    entityViews?: IDropdownOption[];
    fieldError: IFieldError;
    componentId: string;
    previousOutputBlocks: any;
    advancedSettingsIndex: number;
    loadingTemplate: string;
    isFieldChanged: boolean;
    isPropertyChanged: boolean;
    entityOptionSet: IDropdownOption[];
    entityStateCode: IDropdownOption[];
    statusReason: IDropdownOption[];
    outputs: IOutput[];
    output: IOutput;
    entityOutputs: IOutput[];
    fetchXMLOutputs?: IOutput[];

}

export const initialState: IActionConfigState = {
    action: clone(DEFAULT_ACTION),
    fieldConfigs: null,
    entityFields: null,
    fieldError: null,
    componentId: null,
    previousOutputBlocks: {},
    advancedSettingsIndex: null,
    loadingTemplate: null,
    isFieldChanged: null,
    isPropertyChanged: null,
    entityOptionSet: null,
    entityStateCode: null,
    statusReason: null,
    outputs: null,
    output: null,
    entityOutputs: null,
    fetchXMLOutputs: null
};

const actionConfigReducer = function (state: IActionConfigState = initialState, action): IActionConfigState {

    let stateClone: IActionConfigState = clone(state);

    switch (action.type) {

        case types.UPDATE_ACTION_DIALOG:
            stateClone = updateActionDialog(stateClone, action.action, action.fieldConfigs);
            break;

        case types.UPDATE_ACTION_ENTITY_DIALOG:
            stateClone = updateActionEntityDialog(stateClone, action.action);
            break;

        case types.TOGGLE_DIALOG:
            stateClone = toggleDialog(stateClone, action.openModal, action.componentId, action.action, action.previousOutputBlocks);
            break;

        case types.UPDATE_ACTION_OUTPUT:
            stateClone = updateOutput(stateClone, action.index, action.name);
            break;

        case types.UPDATE_ACTION_GLOBAL_OUTPUT:
            stateClone = updateGlobalOutput(stateClone, action.index, action.key);
            break;

        case types.UPDATE_ACTION_OUTPUT_TYPE:
            stateClone = updateOutputType(stateClone, action.index, action.outputType);
            break;

        case types.UPDATE_ACTION_OUTPUT_LOGICAL_NAME:
            stateClone = updateOutputLogicalName(stateClone, action.index, action.logicalName);
            break;

        case types.UPDATE_ACTION_OUTPUT_STATIC_NAME:
            stateClone = updateOutputStaticName(stateClone, action.index, action.staticName);
            break;

        case types.ADD_ACTION_OUTPUT:
            stateClone = addActionOutput(stateClone);
            break;

        case types.ADD_ACTION_OUTPUT_ARRAY:
            stateClone = addActionOutputs(stateClone, action.output);
            break;

        case types.SET_ACTION_OUTPUT_ARRAY:
            stateClone = setActionOutputs(stateClone, action.outputs);
            break;

        case types.REMOVE_ACTION_OUTPUT_ARRAY:
            stateClone = removeActionOutputs(stateClone, action.output);
            break;

        case types.SET_ENTITY_OUTPUTS:
            stateClone = setEntityOutputs(stateClone, action.outputs);
            break;

        case types.SET_FETCHXML_OUTPUTS:
            stateClone = setFetchXMLOutputs(stateClone, action.outputs);
            break;

        case types.SORT_ENTITY_OUTPUTS:
            stateClone = sortEntityOutputs(stateClone, action.outputs, action.modalOutputs);
            break;

        case types.DELETE_ACTION_OUTPUT:
            stateClone = deleteActionOutput(stateClone, action.index);
            break;

        case types.ADD_FIELD:
            stateClone = addField(stateClone);
            break;

        case types.ADD_FIELD_ERROR:
            stateClone = addFieldError(stateClone, action.errorTitle, action.errorMessage);
            break;

        case types.REMOVE_FIELD_ERROR:
            stateClone = removeFieldError(stateClone);
            break;

        case types.SET_ENTITY_FIELDS:
            stateClone = setEntityFields(stateClone, action.entityFields);
            break;

        case types.SET_ENTITY_VIEWS:
            stateClone = setEntityViews(stateClone, action.entityViews);
            break;

        case types.ADD_FIELD_FROM_METADATA:
            stateClone = addFieldFromMetadata(stateClone, action.fieldConfig);
            break;
        // case types.ADD_FIELD_FROM_METADATA:
        //     stateClone = addFieldFromMetadata(stateClone, action.fieldName, action.fieldValue, 0, action.fieldRequired);
        //     break;

        case types.REMOVE_FIELD_FROM_METADATA:
            stateClone = removeFieldFromMetadata(stateClone);
            break;

        case types.ADD_ENTITY_OPTION_SET:
            stateClone = addEntityOptionSet(stateClone, action.entityOptionSet);
            break;

        case types.ADD_ENTITY_STATE_CODE:
            stateClone = addEntityStateCode(stateClone, action.entityStateCode);
            break;

        case types.ADD_STATUS_REASON_SET:
            stateClone = addStatusReason(stateClone, action.statusReason);
            break;

        case types.UPDATE_FIELD_NAME:
            stateClone = updateFieldName(stateClone, action.index, action.name);
            break;

        case types.UPDATE_FIELD_VALUE:
            stateClone = updateFieldValue(stateClone, action.index, action.value);
            break;

        case types.UPDATE_VALUE_OPTIONS_FIELD_VALUE:
            stateClone = updateValueOptionsFieldValue(stateClone, action.index, action.value);
            break;

        case types.SET_IS_FIELD_CHANGED:
            stateClone = setIsFieldChanged(stateClone, action.value);
            break;

        case types.SET_IS_PROPERTY_CHANGED:
            stateClone = setIsPropertyChanged(stateClone, action.value);
            break;

        case types.UPDATE_FIELD_TYPE:
            stateClone = updateFieldType(stateClone, action.index, action.fieldType);
            break;

        case types.UPDATE_FIELD_REQUIRED:
            stateClone = updateFieldRequired(stateClone, action.index, action.fieldRequired);
            break;

        case types.DELETE_FIELD:
            stateClone = deleteField(stateClone, action.index);
            break;

        case types.UPDATE_ACTION_ADVANCED_SETTINGS_INDEX:
            stateClone = updateAdvancedSettingsIndex(stateClone, action.advancedSettingsIndex);
            break;

        case types.UPDATE_ACTION_OUTPUT_LOGICAL_NAME:
            stateClone = updateActionOutputLogicalName(stateClone, action.index, action.logicalName);
            break;

        case types.UPDATE_ACTION_OUTPUT_DEFAULT_VALUE:
            stateClone = updateActionOutputDefaultValue(stateClone, action.index, action.defaultValue);
            break;

        case types.UPDATE_GET_RECORD_ACTION_OUTPUT_DEFAULT_VALUE:
            stateClone = updateGetRecordActionOutputDefaultValue(stateClone, action.logicalName, action.defaultValue);
            break;

        case types.SET_LOADING_TEMPLATE:
            stateClone = setLoadingTemplate(stateClone, action.loadingTemplate);
            break;

        default:
            break;

    }

    return stateClone;

};


let setLoadingTemplate = (state: IActionConfigState, loadingTemplate: string) => {
    state.loadingTemplate = loadingTemplate;
    return state;
};

let getFieldConfigs = (fields: IFieldDictionary) => {

    if (fields) {
        let fieldConfigs: IFieldConfig[] = [];
        for (let fieldName in fields) {
            fieldConfigs.push({
                FieldName: fieldName,
                FieldValue: fields[fieldName].FieldValue,
                ValueOptionsFieldValue: fields[fieldName].ValueOptionsFieldValue,
                FieldType: fields[fieldName].FieldType,
                ValueType: fields[fieldName].ValueType,
                FieldRequired: fields[fieldName].FieldRequired,
                FriendlyName: fields[fieldName].FriendlyName,
                LookupEntityReference: fields[fieldName].LookupEntityReference,
                ValueOptions: fields[fieldName].ValueOptions
            });
        }
        return fieldConfigs;
    }
    else {
        return null;
    }

};

let updateActionDialog = (state: IActionConfigState, action: IAction, fieldConfigs?: IFieldConfig[]) => {
    state.action = action;
    state.fieldConfigs = fieldConfigs ? fieldConfigs : getFieldConfigs(action.Fields);
    return state;
};

let updateActionEntityDialog = (state: IActionConfigState, action: IAction) => {
    state.action = action;
    // state.fieldConfigs = getFieldConfigs(action.Fields);
    return state;
};

let toggleDialog = (state: IActionConfigState, openModal: EModalType, componentId: string, action: IAction, previousOutputBlocks: any): IActionConfigState => {

    if (openModal === EModalType.ActionConfig) {

        state.action = action;
        state.componentId = componentId;
        state.previousOutputBlocks = previousOutputBlocks;
        state.fieldConfigs = getFieldConfigs(action.Fields);
        state.advancedSettingsIndex = null;

    }

    return state;

};

let updateOutput = (state: IActionConfigState, index: number, name: string): IActionConfigState => {

    let output = state.action.OutputValues[index];
    output.Name = name;

    return state;

};

let updateGlobalOutput = (state: IActionConfigState, index: number, outputId: string): IActionConfigState => {

    let output = state.action.OutputValues[index];
    output.GlobalOutputId = outputId;

    return state;

};

let updateOutputType = (state: IActionConfigState, index: number, outputType: number) => {

    let output = state.action.OutputValues[index];
    output.Type = outputType;

    return state;

};

let updateOutputLogicalName = (state: IActionConfigState, index: number, logicalName: string) => {

    let output = state.action.OutputValues[index];
    output.LogicalName = logicalName;

    return state;

};

let updateOutputStaticName = (state: IActionConfigState, index: number, staticName: string) => {

    let output = state.action.OutputValues[index];
    output.StaticName = staticName;
    output.Type = state.action.OutputValueOptions.filter(o => o.StaticName === staticName)[0].Type;

    return state;

};

let addActionOutput = (state: IActionConfigState) => {

    let outputs = state.action.OutputValues;
    let output: IOutput = clone(DEFAULT_ACTION_OUTPUT);
    output.Id = IdHelper.newGuid();
    outputs.push(
        output
    );

    return state;

};

let addActionOutputs = (state: IActionConfigState, output: IOutput) => {
    let outputs = state.action.OutputValues;
    if (outputs) {
        output.LogicalName = output.LogicalName
        outputs.push(output)
    } else {
        state.action.OutputValues = [output]
    }
    return state;
};

let removeActionOutputs = (state: IActionConfigState, output: IOutput) => {
    let outputs = state.action.OutputValues;
    state.action.OutputValues = outputs.filter(x => x.LogicalName !== output.LogicalName);
    return state;
};

let setActionOutputs = (state: IActionConfigState, outputs: IOutput[]) => {
    state.action.OutputValues = outputs
    // let outputs = state.action.OutputValues;
    // let output: IOutput = clone(DEFAULT_ACTION_OUTPUT);
    // output.Id = IdHelper.newGuid();
    // outputs.push(
    //     output
    // );

    return state;

};

let setEntityOutputs = (state: IActionConfigState, outputs: IOutput[]) => {
    state.entityOutputs = outputs
    return state;
};

let setFetchXMLOutputs = (state: IActionConfigState, outputs: IOutput[]) => {
    state.fetchXMLOutputs = outputs
    return state;
};

let sortEntityOutputs = (state: IActionConfigState, outputs: IOutput[], modalOutputs: IOutput[]) => {

    const modalOutputsToCheck = modalOutputs && modalOutputs.map(x => x.LogicalName);

    // sort outputs to show the outputs with values at first
    const sortedFilteredOutputs = outputs && outputs.sort((a, b) => {
        if (modalOutputsToCheck.indexOf(a.LogicalName) < 0) {
            return 1;
        }
        if (modalOutputsToCheck.indexOf(b.LogicalName) < 0) {
            return -1;
        }

        if (a.LogicalName === b.LogicalName) {
            return 0;
        }

        return 1;
    });

    state.entityOutputs = sortedFilteredOutputs;
    return state;
};

let deleteActionOutput = (state: IActionConfigState, index: number) => {

    state.action.OutputValues.splice(index, 1);

    return state;

};

let addField = (state: IActionConfigState) => {

    // state.fieldConfigs.push({
    //     FieldName: '',
    //     FieldValue: '',
    //     FieldType: 0
    // });

    return state;

};

let setEntityFields = (state: IActionConfigState, entityFields: IDropdownOption[]) => {
    state.entityFields = entityFields;
    return state;
};
let setEntityViews = (state: IActionConfigState, entityViews: IDropdownOption[]) => {
    state.entityViews = entityViews;
    return state;
};

let addFieldError = (state: IActionConfigState, errorTitle: string, errorMessage: string) => {
    const fieldError = {
        ErrorTitle: errorTitle,
        ErrorMessage: errorMessage
    }
    state.fieldError = fieldError;

    return state;
};

let removeFieldError = (state: IActionConfigState) => {
    state.fieldError = null;

    return state;

};

let addFieldFromMetadata = (state: IActionConfigState, fieldConfig: IFieldConfig[]) => {
    state.fieldConfigs = fieldConfig;
    return state;

};
// let addFieldFromMetadata = (state: IActionConfigState, fieldName: string, fieldValue: string, fieldType: number = 0, fieldRequired: boolean) => {
//     const filedConfigData: IFieldConfig = {
//         FieldName: fieldName,
//         FieldValue: fieldValue,
//         FieldType: fieldType,
//         FieldRequired: fieldRequired
//     }
//     state.fieldConfigs.push(filedConfigData);

//     return state;

// };
let removeFieldFromMetadata = (state: IActionConfigState) => {

    state.fieldConfigs = null

    return state;

};

let addEntityOptionSet = (state: IActionConfigState, entityOptionSet: IDropdownOption[]) => {

    state.entityOptionSet = entityOptionSet

    return state;

};
let addEntityStateCode = (state: IActionConfigState, entityStateCode: IDropdownOption[]) => {

    state.entityStateCode = entityStateCode

    return state;

};

let addStatusReason = (state: IActionConfigState, statusReason: IDropdownOption[]) => {

    state.statusReason = statusReason

    return state;

};

let updateFieldName = (state: IActionConfigState, index: number, name: string): IActionConfigState => {

    state.fieldConfigs[index].FieldName = name;

    return state;

};

let updateFieldValue = (state: IActionConfigState, index: number, value: string): IActionConfigState => {

    if (state.fieldConfigs[index].FieldValue !== value) {
        state.fieldConfigs[index].FieldValue = value;
        state.isFieldChanged = true;
    }

    return state;

};

let updateValueOptionsFieldValue = (state: IActionConfigState, index: number, value: string): IActionConfigState => {

    if (state.fieldConfigs[index].ValueOptionsFieldValue !== value) {
        state.fieldConfigs[index].ValueOptionsFieldValue = value;
        state.isFieldChanged = true;
    }

    return state;

};

let setIsFieldChanged = (state: IActionConfigState, value: boolean): IActionConfigState => {

    state.isFieldChanged = value;

    return state;

};

let setIsPropertyChanged = (state: IActionConfigState, value: boolean): IActionConfigState => {

    state.isPropertyChanged = value;

    return state;

};

let updateFieldType = (state: IActionConfigState, index: number, fieldType: number): IActionConfigState => {

    state.fieldConfigs[index].FieldType = fieldType;

    return state;

};

let updateFieldRequired = (state: IActionConfigState, index: number, fieldRequired: boolean): IActionConfigState => {

    state.fieldConfigs[index].FieldRequired = fieldRequired;

    return state;

};

let deleteField = (state: IActionConfigState, index: number): IActionConfigState => {

    state.fieldConfigs.splice(index, 1);

    return state;

};

let updateAdvancedSettingsIndex = (state: IActionConfigState, advancedSettingsIndex: number): IActionConfigState => {

    state.advancedSettingsIndex = advancedSettingsIndex;

    return state;

};

let updateActionOutputLogicalName = (state: IActionConfigState, index: number, logicalName: string): IActionConfigState => {

    state.action.OutputValues[index].LogicalName = logicalName;

    return state;

};

let updateActionOutputDefaultValue = (state: IActionConfigState, index: number, defaultValue: string): IActionConfigState => {

    state.action.OutputValues[index].PrepopulatedValue = defaultValue;

    return state;

};

let updateGetRecordActionOutputDefaultValue = (state: IActionConfigState, logicalName: string, defaultValue: string): IActionConfigState => {

    state.action.OutputValues.filter(x => x.LogicalName.toLowerCase() === logicalName.toLowerCase())[0].PrepopulatedValue = defaultValue;

    // exclude from entityOutputs
    state.entityOutputs && state.entityOutputs.filter(x => x.LogicalName.toLowerCase() === logicalName.toLowerCase())[0] ?
        state.entityOutputs.filter(x => x.LogicalName.toLowerCase() === logicalName.toLowerCase())[0].PrepopulatedValue = defaultValue
        : null;

    // exclude from fetchXMLOutputs
    state.fetchXMLOutputs && state.fetchXMLOutputs.filter(x => x.LogicalName.toLowerCase() === logicalName.toLowerCase())[0] ?
        state.fetchXMLOutputs.filter(x => x.LogicalName.toLowerCase() === logicalName.toLowerCase())[0].PrepopulatedValue = defaultValue
        : null;

    return state;

};

export default actionConfigReducer;



// WEBPACK FOOTER //
// ./source/ts/store/reducers/action-config.ts